import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { accessControl } from 'utils/accessControl';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const location = useLocation();

  // Check if the current path is the Zone Details page - allow public access
  const isZoneDetailsPage = location.pathname.match(/\/admin\/(warehouse|finished-products)\/zones?\/\d+/);
  
  if (isZoneDetailsPage) {
    return children;
  }

  // Check authentication
  const loginData = localStorage.getItem('usibras_login');
  const userData = localStorage.getItem('usibras_user_data');
  
  if (!loginData && !userData) {
    return <Navigate to="/auth/sign-in" />;
  }

  try {
    // Refresh permissions to ensure we have latest data
    accessControl.refreshPermissions();

    // Check specific permission if required
    if (requiredPermission && !accessControl.canAccessMenu(requiredPermission)) {
      return <Navigate to={accessControl.getLandingPage()} />;
    }

    // Handle default redirects for restricted paths
    const restrictedPaths = ['/admin/default', '/admin/users-view', '/admin/users-add'];
    if (restrictedPaths.includes(location.pathname)) {
      return <Navigate to={accessControl.getLandingPage()} />;
    }

    // Check warehouse dashboard access
    if (location.pathname === '/admin/warehouse/dashboard' || location.pathname === '/admin/warehouse') {
      const { role, unit } = accessControl.getUserInfo() || {};
      if (role !== 'admin' && unit !== 'RCN Warehouse') {
        return <Navigate to={accessControl.getLandingPage()} />;
      }
    }

    return children;
  } catch (error) {
    console.error('Error in ProtectedRoute:', error);
    return <Navigate to="/auth/sign-in" />;
  }
};

export default ProtectedRoute;